import React from "react";
import {Form, Input, Modal, Radio, Select} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import ApplicationPresenter from "../../.gen/presenter/ApplicationPresenter";
import {ifTrue} from "../../redare/utils/Utils";
import UploadImg from "../../components/common/UploadImg";
import RadioGroup from "antd/es/radio/group";

const {TextArea} = Input;

export default class ApplicationForm extends BaseComponent {
    static defaultProps={
        onAddSuccess:undefined,//添加回调
        onEditSuccess:undefined//编辑回调
    }
    formDataExt = {};
    constructor(props) {
        super(props);
        this.applicationPresenter=new ApplicationPresenter(this);
        this._user = window._workbench._user;
        this._form.platform = this._user.platform;
        this.state = {loading:false};
    }

    componentDidMount() {

    }

    loadInfo(id){
        if ( !ifTrue(id)) {
            return;
        }
        this.applicationPresenter.getApplication({id}, {}, (result) => {
            this.formRef.setFieldsValue(result.data);
            if(result.data.icon){
                this.uploadImg._setPreviewImg(result.data.icon);
            }
            this.setState({radioValue:result.data.showPage});
            this.setState({data: result.data});
        });
    }

    //关闭窗口
    _closeForm() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    async getFormData(){
        let saveData = {};
        let values = {};
        try {
          values = await this.formRef.validateFields();
        }catch (e) {
            Modal.error({
                title: '请完整表单内容',
                centered: true,
                okText: '确定'
            });
            return ;
        }
        let formDataExt = this.formDataExt;
        let icon = this.uploadImg.state.previewImage;
        formDataExt.icon=icon;
        if (values.showApp === undefined){
            values.showApp = 0;
        }
        if (values.showPage === undefined){
            values.showPage = 0;
        }
        if (values.status === undefined){
            values.status = 1;
        }
        if (values.isShowApp === undefined){
            values.isShowApp = 1;
        }
        if (values.isShowPC === undefined){
            values.isShowPC = 1;
        }
        if (values.verifyAccountAndPwd === undefined){
            values.verifyAccountAndPwd = 1;
        }

        saveData = {...values,...formDataExt};

        //新增
        if (this.props.onAddSuccess) {
            saveData={...values,}
        }
        //修改
        if (this.props.onEditSuccess) {
            let {data}=this.state;
            if(data){
                data.roleIds = undefined;
                data.orgIds = undefined;
                data.pcRoleIds = undefined;
                data.pcOrgIds = undefined;
                saveData = {...data, ...values,};
            }
        }
        return saveData;
    }

    //保存
    _onSubmit() {
        this.setState({loading:true});
        this.formRef.validateFields()
            .then(values=>{
                let formDataExt = this.formDataExt;
                let icon = this.uploadImg.state.previewImage;
                formDataExt.icon=icon;
                if (values.showApp === undefined){
                    values.showApp = 0;
                }
                if (values.showPage === undefined){
                    values.showPage = 0;
                }
                if (values.status === undefined){
                    values.status = 1;
                }
                if (values.isShowApp === undefined){
                    values.isShowApp = 1;
                }
                if (values.isShowPC === undefined){
                    values.isShowPC = 1;
                }
                if (values.verifyAccountAndPwd === undefined){
                    values.verifyAccountAndPwd = 1;
                }
                //新增
                if (this.props.onAddSuccess) {
                    let saveData={...values,...formDataExt}
                    this.applicationPresenter.addApplication(saveData,{},(result)=>{
                        this.setState({loading:false});
                        this.toastSuccess("添加成功!");
                        this.props.onAddSuccess();
                    },()=>{
                        this.setState({loading:false});
                    });

                }
                //修改
                if (this.props.onEditSuccess) {
                    let {data}=this.state;
                    let saveData={};
                    if(data){
                        data.roleIds = undefined;
                        data.orgIds = undefined;
                        data.pcRoleIds = undefined;
                        data.pcOrgIds = undefined;
                        saveData = {...data, ...values,...formDataExt};
                    }
                    this.applicationPresenter.editApplication(saveData,{},(result)=>{
                        this.setState({loading:false});
                        this.toastSuccess("修改成功!");
                        this.props.onEditSuccess();
                    });
                }
            }).catch(fail_re => {

        });


    }

    _RadioChange(e){
        this.setState({radioValue:e.target.value})
    }

    render() {
        let defaultRules = function (title, type) {
            if (!type) {
                type = '输入'
            }
            return [{required: true, message: '请' + type + title}];
        };

        let {radioValue} = this.state;
        if (!radioValue){
            radioValue = 0;
        }

        let {treeData} = this.state;
        if (!treeData){
            treeData = [];
        }

        const tProps = {
            treeData,
            treeCheckable: true,
            placeholder: '请选择可访问单位',
            style: {
                width: '100%',
            },
        };

        return (
            <>
                <Form labelAlign='right' layout='vertical' ref={(o)=>this.formRef=o}>
                    <Form.Item label="系统编码" name="sysCode" rules={[{required:true,message:'系统编码不能为空'}]}>
                        <Input placeholder="请输入系统编码" />
                    </Form.Item>
                    <Form.Item label="应用名称" name="name" rules={[{required:true,message:'应用名称不能为空'}]}>
                        <Input placeholder="请输入应用名称" />
                    </Form.Item>
                    <Form.Item label="应用图标" name="icon" >
                        <UploadImg ref={(the) => {
                            this.uploadImg = the
                        }}/>
                    </Form.Item>
                    <Form.Item label="分类" name="classify" rules={[{required:true,message:'分类不能为空'}]}>
                        <Select placeholder="应用分类">
                            <Select.Option value="eventcenter">事件中心</Select.Option>
                            <Select.Option value="application">应用</Select.Option>
                            <Select.Option value="datacenter">数据中心</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="应用访问Code" name="accessCode" rules={[{required:true,message:'应用访问Code不能为空'}]}>
                        <Input placeholder="请输入应用访问Code" />
                    </Form.Item>
                    <Form.Item label="应用访问密钥" name="accessKey" rules={[{required:true,message:'应用访问密钥不能为空'}]}>
                        <Input placeholder="请输入应用访问密钥" />
                    </Form.Item>
                    <Form.Item label="应用访问链接" name="appAccessUrl" rules={[{required:true,message:'应用访问链接不能为空'}]}>
                        <Input placeholder="请输入应用访问链接" />
                    </Form.Item>
                    <Form.Item label="应用访问链接请求头参数" name="appAccessHeadParam">
                        <Input placeholder="请以json格式输入请求头参数" />
                    </Form.Item>
                    <Form.Item label="应用访问链接请求体参数" name="appAccessBodyParam">
                        <Input placeholder="请以json格式输入请求体参数" />
                    </Form.Item>
                    <Form.Item label="验证账号密码的请求地址" name="verifyUrl" rules={[{required:true,message:'验证账号密码的请求地址不能为空'}]}>
                        <Input placeholder="请输入验证地址" />
                    </Form.Item>
                    <Form.Item label="验证账号密码请求头参数" name="verifyHeadParam">
                        <Input placeholder="请以json格式输入请求头参数" />
                    </Form.Item>
                    <Form.Item label="验证账号密码请求体参数" name="verifyBodyParam" rules={[{required:true,message:'验证账号密码请求体参数不能为空'}]}>
                        <Input placeholder='请以json格式输入请求体参数,如{"accountField":"请求接口对应的账号字段","passwordField":"请求接口对应的密码字段"}' />
                    </Form.Item>
                    <Form.Item label="验证账号密码响应参数" name="verifyResponseParam" rules={[{required:true,message:'验证账号密码响应参数不能为空'}]}>
                        <Input placeholder='请以json格式输入响应参数,如{"userId":"接口返回用户id字段名","success":"接口返回成功标识字段名"}' />
                    </Form.Item>

                    {/*<Form.Item label="待办事项请求地址" name="gtasksUrl" rules={[{required:true,message:'待办事项请求地址不能为空'}]}>*/}
                    {/*    <Input placeholder="请输入待办事项请求地址"/>*/}
                    {/*</Form.Item>*/}
                    {/*<Form.Item label="待办事项请求头参数" name="gtasksHeadParam">*/}
                    {/*    <Input placeholder="请以json格式输入待办事项请求头参数"/>*/}
                    {/*</Form.Item>*/}
                    {/*<Form.Item label="待办事项请求体参数" name="gtasksBodyParam" >*/}
                    {/*    <Input placeholder="请以json格式输入待办事项请求体参数"/>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item label="移动端可访问用户角色" name="roleIdList" trigger="onValueChange" validateTrigger="onValueChange">*/}
                    {/*    <RoleSelect platform={this._form.platform}/>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item label="移动端可访问单位" name="orgIdList">*/}
                    {/*    <TreeSelect {...tProps}/>*/}
                    {/*</Form.Item>*/}


                    {/*<Form.Item label="pc端可访问用户角色" name="pcRoleIdList" trigger="onValueChange" validateTrigger="onValueChange">*/}
                    {/*    <RoleSelect platform={this._form.platform}/>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item label="pc端可访问单位" name="pcOrgIdList">*/}
                    {/*    <TreeSelect {...tProps}/>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item name="showApp" label="是否显示在app首页" >*/}
                    {/*    <RadioGroup defaultValue={0}>*/}
                    {/*        <Radio value={0}>否</Radio>*/}
                    {/*        <Radio value={1}>是</Radio>*/}
                    {/*    </RadioGroup>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item name="showPage" label="是否跳转到H5页面" >*/}
                    {/*    <RadioGroup defaultValue={0} onChange={this._RadioChange.bind(this)}>*/}
                    {/*        <Radio value={0}>否</Radio>*/}
                    {/*        <Radio value={1}>是</Radio>*/}
                    {/*    </RadioGroup>*/}
                    {/*</Form.Item>*/}

                    {/*{*/}
                    {/*    Number(radioValue) === 0?"":*/}
                    {/*        <Form.Item label="跳转H5页面地址" name="pageUrl" rules={[{required:true,message:'跳转H5页面地址不能为空'}]}>*/}
                    {/*            <Input placeholder="请输入跳转H5页面地址" />*/}
                    {/*        </Form.Item>*/}
                    {/*}*/}

                    <Form.Item name="status" label="应用启用状态" >
                        <RadioGroup defaultValue={1}>
                            <Radio value={0}>停用</Radio>
                            <Radio value={1}>启用</Radio>
                        </RadioGroup>
                    </Form.Item>

                    {/*<Form.Item name="appPage" label="APP页面" rules={[{required:true,message:'APP页面不能为空'}]}>*/}
                    {/*    <Input placeholder="请输入APP页面"/>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item name="isShowApp" label="是否在手机端应用显示" >*/}
                    {/*    <RadioGroup defaultValue={1}>*/}
                    {/*        <Radio value={0}>否</Radio>*/}
                    {/*        <Radio value={1}>是</Radio>*/}
                    {/*    </RadioGroup>*/}
                    {/*</Form.Item>*/}

                    {/*<Form.Item name="isShowPC" label="是否在PC端应用显示" >*/}
                    {/*    <RadioGroup defaultValue={1}>*/}
                    {/*        <Radio value={0}>否</Radio>*/}
                    {/*        <Radio value={1}>是</Radio>*/}
                    {/*    </RadioGroup>*/}
                    {/*</Form.Item>*/}

                    <Form.Item name="verifyAccountAndPwd" label="是否验证账号密码" >
                        <RadioGroup defaultValue={1}>
                            <Radio value={0}>否</Radio>
                            <Radio value={1}>是</Radio>
                        </RadioGroup>
                    </Form.Item>

                    {/*<Form.Item label="排序" name="sort">*/}
                    {/*    <InputNumber placeholder="请输入排序值(值为数字，根据数字大小升序排序)" />*/}
                    {/*</Form.Item>*/}
                    <Form.Item label="备注" name="remark">
                        <TextArea rows={4} />
                    </Form.Item>
                </Form>

            </>
        )
    }
}
